export default "__VITE_ASSET__6cce68be__"